<template>
  <div id="eligible_professionals">
    <Navbar current="Profissionais elegíveis" />
    <Sidebar />
    <Container col="col-12">
      <Header
        title="Profissionais elegíveis"
        icon="fa-solid fa-user-check"
        :count="totalItemsRegistered"
        subtitle="Usuários que enviaram o cadastro de profissional para aprovação, para poder atender consultas"
      />
      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{
              active: filters.status === EProfessionalApprovalStatus.PENDING,
            }"
            href="#"
            @click.prevent="changeTab(EProfessionalApprovalStatus.PENDING)"
            >Pendentes</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{
              active: filters.status === EProfessionalApprovalStatus.APPROVED,
            }"
            href="#"
            @click.prevent="changeTab(EProfessionalApprovalStatus.APPROVED)"
            >Aprovados</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{
              active: filters.status === EProfessionalApprovalStatus.REJECTED,
            }"
            href="#"
            @click.prevent="changeTab(EProfessionalApprovalStatus.REJECTED)"
            >Reprovados</a
          >
        </li>
      </ul>

      <div class="card">
        <LoadingContainer v-if="loadingItems" />
        <template v-else>
          <EmptyState
            v-if="!professionals.length"
            icon="fa-solid fa-user-check"
            :title="emptyStateTitle"
            :noMsg="true"
          />
          <div v-else class="table-responsive">
            <table
              class="table table-sm table-nowrap card-table table-hover cursor-pointer"
            >
              <TableHead :columns="columns" />
              <tbody class="list">
                <router-link
                  tag="tr"
                  v-for="(item, index) in professionals"
                  v-bind:key="'tr-' + index"
                  :to="{
                    path: `${$paths.users.detail}/${item.user_id}`,
                    query: { tab: 'profissional' },
                  }"
                >
                  <td>{{ item.name }}</td>
                  <td class="text-end">
                    <span class="badge fw-bold" :class="item.statusBadge.bg"
                      >{{ item.statusBadge.title }}
                      <span v-if="item.formattedRejectionStep"
                        >- {{ item.formattedRejectionStep }}</span
                      >
                    </span>
                  </td>
                </router-link>
              </tbody>
            </table>
          </div>
        </template>
      </div>
      <div class="row" v-if="!loadingItems">
        <div class="col-12 text-end">
          <span class="text-muted"
            >mostrando <b>{{ countItemsShowing }}</b> de
            <b>{{ countItemsTotal }}</b> resultado(s)</span
          >
        </div>
      </div>
      <div
        class="row justify-content-center"
        v-if="!loadingItems && moreItemsToLoad"
      >
        <div class="col-2">
          <FormButton
            label="Carregar mais"
            :loading="loadingMoreItems"
            @onClick="loadMore"
          />
        </div>
      </div>
    </Container>
  </div>
</template>
<script>
import EligibleProfessionalsController from "./EligibleProfessionalsController";
export default EligibleProfessionalsController;
</script>
